//Parroquia Nueva Esparta
const munAntolinDelCampo = ['Antolin Del Campo'];
const munArismendiNuevaEsparta = ['Arismendi'];
const munDíaz = ['Díaz', 'Zabala'];
const munGarcía = ['García', 'Francisco Fajardo'];
const munGómez = ['Gómez', 'Bolívar', 'Guevara', 'Matasiete', 'Sucre'];
const munManeiro = ['Maneiro', 'Aguirre'];
const munMarcano = ['Marcano', 'Adrián'];
const munMariño = ['Mariño'];
const munPenínsuladeMacanao = ['Península de Macanao', 'San Francisco'];
const munTubores = ['Tubores', 'Los Barales'];
const munVillalba = ['Villalba', 'Vicente Fuentes'];

export const esNuevaEsparta = [
  {
    municipio: 'Antolin Del Campo',
    parroquias: munAntolinDelCampo,
  },
  {
    municipio: 'Arismendi',
    parroquias: munArismendiNuevaEsparta,
  },
  {
    municipio: 'Díaz',
    parroquias: munDíaz,
  },
  {
    municipio: 'García',
    parroquias: munGarcía,
  },
  {
    municipio: 'Gómez',
    parroquias: munGómez,
  },
  {
    municipio: 'Maneiro',
    parroquias: munManeiro,
  },
  {
    municipio: 'Marcano',
    parroquias: munMarcano,
  },
  {
    municipio: 'Mariño',
    parroquias: munMariño,
  },
  {
    municipio: 'Península de Macanao',
    parroquias: munPenínsuladeMacanao,
  },
  {
    municipio: 'Tubores',
    parroquias: munTubores,
  },
  {
    municipio: 'Villalba',
    parroquias: munVillalba,
  },
];
